import { SERVER_API_URL, WEBSOCKET_URL } from '../config/Constants';


import { createCable } from '@anycable/web'

const URL = WEBSOCKET_URL + '/cable';

export default createCable(URL)